import React from 'react';
import { Redirect } from 'react-router-dom';


export default function LogOut() {
  return (<Redirect to="/login" />)
}
